import React, { useState, useEffect } from "react";
import {
  Icon,
  Form,
  List,
  Table,
  Button,
  Checkbox,
  Input,
  Label,
} from "semantic-ui-react";
import Select, { createFilter } from "react-select";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../services/auth";
import { Container, Title, ValorFinal } from "./styled";
import { producaov2 } from "../../../services/apis";
import swal from "sweetalert";
import { limpaTituloCurso } from "../../../utils/Utils";
import { systemLogs } from "../../../services/system_logs";

function Pagamentos() {
  const [searchAluno, setSearchAluno] = useState("");
  const [alunos, setAlunos] = useState([]);
  const [currentAluno, setCurrentAluno] = useState("");
  const [cursos, setCursos] = useState([]);
  const [currentCurso, setCurrentCurso] = useState([]);
  const [cpf, setCpf] = useState("");
  const [cep, setCep] = useState("");
  const [endereco, setEndereco] = useState("");
  const [numero, setNumero] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [numCursos, setNumCursos] = useState(1);
  const [valorFinal, setValorFinal] = useState(0);
  const [modal, setModal] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadAuth();
    let allCourses = [];
    for (let index = 1; index <= 9; index++) {
      if (index !== 8) {
        producaov2.get(`curso/area/${index}?limit=100`).then((res) => {
          res.data.map((v) => {
            v.name = v.titulo + " - " + v.id;
            v.label = v.titulo + " - " + v.id;
            v.value = v.id;
            allCourses.push(v);
          });
          setCursos(allCourses);
          // console.log(allCourses)
        });
      }
    }
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  useEffect(() => {
    if (searchAluno.length > 1) {
      const cleanSearch = searchAluno.trim();
      producaov2
        .get(`alunos?page=1&search=${cleanSearch}&limit=20`)
        .then((res) => {
          setAlunos(res.data);
          // console.log(allCourses)
        });
    }
  }, [searchAluno]);

  function setterSearch(index, value) {
    let oldValues = currentCurso;
    if (value == null) {
      oldValues[index] = "";
    } else {
      oldValues[index] = value.id;
    }
    setCurrentCurso(oldValues);
  }

  function setterAluno(info) {
    producaov2
      .get(`/alunos/${info.id}`)
      .then((res) => {
        setCpf(res.data.aluno.cpf);
        setCep(res.data.aluno.cep);
        setEndereco(res.data.aluno.endereco);
        setNumero(res.data.aluno.numero);
        setBairro(res.data.aluno.bairro);
        setCidade(res.data.aluno.cidade);
        setEstado(res.data.aluno.estado);
        setCurrentAluno(res.data.aluno);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function renderCursos() {
    const content = [];
    for (let index = 0; index < numCursos; index++) {
      content.push(
        <Form style={{ marginTop: 20 }}>
          <b>{index + 1}º Curso</b>
          <Form.Field>
            <label>Busque o curso pelo ID ou pelo seu nome</label>
            <Select
              name={`curso${index}`}
              onChange={(e) => setterSearch(index, e)}
              defaultValue={""}
              isClearable
              isSearchable
              options={cursos}
              placeholder="Busque o curso pelo id ou pelo nome"
              filterOption={createFilter({
                ignoreCase: true,
                ignoreAccents: true,
                trim: false,
                matchFromStart: false,
              })}
            />
          </Form.Field>

          <Form.Field>
            <label>Será enviado algum sub-items?</label>
            <Checkbox label="Material" id={`materialOpt${index}`} />
            <Checkbox label="Certificado" id={`certificadoOpt${index}`} />
          </Form.Field>

          <Form.Field>
            <label>Valor individual do item</label>
            <Input
              type="number"
              defaultValue="1"
              min="1"
              min-length="1"
              id={`valorItem${index}`}
              onChange={() => totalReturn()}
              labelPosition="right"
              placeholder="Valor do item"
            >
              <Label>R$</Label>
              <input />
              <Label>.00</Label>
            </Input>
          </Form.Field>
        </Form>
      );
    }
    return content;
  }

  function renderAlunos() {
    if (alunos.length <= 0) {
      return (
        <List.Item>
          <List.Content>Nenhum aluno encontrado</List.Content>
        </List.Item>
      );
    }
    const alunosFilter = alunos.filter(
      (v) =>
        v.email.toLowerCase().indexOf(searchAluno.toLowerCase()) > -1 ||
        v.id == searchAluno ||
        v.nome.toLowerCase().indexOf(searchAluno.toLowerCase()) > -1
    );
    return alunosFilter.map((v) => (
      <List.Item
        id={`aluno${v.id}`}
        style={{ cursor: "pointer" }}
        onClick={() => window.open(`/admin/pagamentos/gerar/${v.id}`)}
      >
        <List.Content>
          [{v.id}] - {v.email} - {v.nome}
        </List.Content>
      </List.Item>
    ));
  }

  function returnNamesCourses() {
    const promisesCoursesName = [];
    for (let index = 0; index < numCursos; index++) {
      let curso = currentCurso[index];
      promisesCoursesName.push(producaov2.get("/cursolist/" + curso));
    }
    return new Promise((resolve, reject) => {
      Promise.all(promisesCoursesName)
        .then((v) => {
          let names = "";
          v.map((l, i) => {
            names += limpaTituloCurso(l.data.titulo);
            if (v.length !== i + 1) {
              names += ", ";
            }
          });
          resolve(names);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  function pedidoJsonCreate(cursosPedido, total = 0, id_pedido) {
    let pedido = {};

    pedido.cartID = "link_gerado";

    pedido.cupom = "";

    pedido.tipo = 5;
    if (cursosPedido.length > 1) {
      pedido.cursos = [];
      cursosPedido.map((l) => {
        pedido.cursos.push(l);
      });
    } else {
      pedido.cursos = cursosPedido;
    }

    pedido.descontoStr = "";
    pedido.desconto = 0;

    pedido.obs = "";

    pedido.pagamento = "escolha";

    pedido.parcelas = 0;

    pedido.pessoa = currentAluno.id;
    pedido.total = total;
    pedido.valor_parcela = 0;

    return {
      data: new Date(),
      status: 70,
      tipo: 5,
      obs: "",
      valor_parcela: pedido.valor_parcela,
      json: JSON.stringify(pedido),
      tipo_pagamento: "LINK GERADO",
      id_pedido,
    };
  }

  async function finalizar() {
    let materiais = [];
    let certificados = [];
    let cursosPedido = [];
    let pedidosSeparados = [];
    for (let index = 0; index < numCursos; index++) {
      let curso = currentCurso[index];
      let materiaisCurrentCurso = [];
      let certificadoCurrentCurso = [];

      let materialOnly = false; //document.getElementById(`materialOnly${index}`).checked
      let valor = document.getElementById(`valorItem${index}`).value;
      if (curso === undefined || curso === undefined) {
        swal(
          "Dados incompletos",
          `Informe um curso válido no item ${index + 1}`,
          "error"
        );
        return false;
      }
      if (
        valor === undefined ||
        valor === null ||
        isNaN(valor) === true ||
        valor <= 1
      ) {
        swal(
          "Dados incompletos",
          `Informe um valor válido e maior que R$1.00 no item ${index + 1}`,
          "error"
        );
        return false;
      }

      let material = document.getElementById(`materialOpt${index}`).checked;
      if (material) {
        materiais.push(curso);
        materiaisCurrentCurso.push(curso);
      }

      let certificado = document.getElementById(`certificadoOpt${index}`)
        .checked;
      if (certificado) {
        certificados.push(curso);
        certificadoCurrentCurso.push(curso);
      }

      cursosPedido.push({
        id: curso,
        materiais: materiaisCurrentCurso,
        certificados: certificadoCurrentCurso,
        taxas: 0,
        cupom: "",
        desconto: 0,
        valorProduto: valor,
        listaEspera: false,
      });

      pedidosSeparados.push({
        cursoPedido: {
          id: curso,
          id_curso: curso,
          materiais: materiaisCurrentCurso,
          certificados: certificadoCurrentCurso,
          taxas: 0,
          cupom: "",
          desconto: 0,
          valorProduto: valor,
          listaEspera: false,
        },
        total: valor,
        materiais,
        certificados,
      });
    }

    setLoading(true);

    const params = pedidoJsonCreate(cursosPedido, totalReturn());
    try {
      const nameCourses = await returnNamesCourses();
      //MUDAR API AQUI
      producaov2
        .post("admin/pedido_only/", params)
        .then((v) => {
          const pedido_id_recent = v.data.data.id;
          const promisesPco = [];
          pedidosSeparados.map((v) => {
            let paramsCreate = v;
            paramsCreate.id_pedido = pedido_id_recent;
            promisesPco.push(
              producaov2.post(
                "/admin/pessoa_curso_only/",
                pedidoJsonCreate(
                  paramsCreate.cursoPedido,
                  paramsCreate.total,
                  pedido_id_recent
                )
              )
            );
          });
          Promise.all(promisesPco)
            .then((v) => {
              producaov2
                .post("mail/send", {
                  model: 20,
                  context: {
                    nome: currentAluno.nome,
                    curso: nameCourses,
                    hashcode: pedido_id_recent,
                  },
                  assunto: `Link de pagamento para realizar sua inscrição`,
                  email: currentAluno.email,
                  cc: "comercial@voitto.com.br,financeiro@voitto.com.br,",
                })
                .then((v) => {
                  swal(
                    "Sucesso!",
                    `O link de pagamento foi enviado para o usuário!`,
                    "success"
                  );
                  setLoading(false);

                  systemLogs(
                    "pagamento",
                    `Enviou um link de pagamento para o usuario ${
                      currentAluno.id
                    } - ${
                      currentAluno.email
                    } no valor de para ${totalReturn()} os cursos ${nameCourses}. ID DO PEDIDO: ${pedido_id_recent}`
                  );
                })
                .catch((error) => {
                  setLoading(false);
                  swal(
                    "Ops :(",
                    `Houve um erro ao enviar o email do link de pagamento, informe ao TI imediatamente`,
                    "error"
                  );
                  console.log("error pc create", error);
                  return true;
                });
            })
            .catch((error) => {
              setLoading(false);
              swal(
                "Ops :(",
                `Houve um erro ao criar um registro de inscrição do curso, informe ao TI imediatamente`,
                "error"
              );
              console.log("error pc create", error);
              return true;
            });
        })
        .catch((error) => {
          setLoading(false);
          swal(
            "Ops :(",
            "Houve um erro ao criar o pedido, informe ao TI imediatamente",
            "error"
          );
          console.log("erro ao criar pedido", error);
        });
    } catch (error) {
      swal(
        "Ops :(",
        `Houve um erro ao pegar os nomes dos cursos para o email, informe ao TI imediatamente`,
        "error"
      );
    }
  }

  function totalReturn() {
    let total = 0;
    for (let index = 0; index < numCursos; index++) {
      let valor =
        document.getElementById(`valorItem${index}`) !== null &&
        document.getElementById(`valorItem${index}`) !== ""
          ? parseFloat(document.getElementById(`valorItem${index}`).value)
          : 0;
      total += isNaN(valor) ? 0 : valor;
    }
    setValorFinal(parseFloat(total).toFixed(2));
    return parseFloat(total).toFixed(2);
  }

  // function sendLink(){

  // }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container style={{ paddingBottom: 60 }}>
        <Title>Gerar link de pagamento</Title>
        <Button
          info="Link"
          title="O link é recorrente?"
          onClick={() => window.open(`/admin/planos/link`)}
        >Link é recorrente ?</Button>



        {currentAluno === "" ? (
          <>
            <Form>
              <Form.Field>
                <label style={{marginTop: "1rem"}}>Selecione o aluno</label>
                <input
                  value={searchAluno}
                  onChange={(e) => setSearchAluno(e.target.value)}
                  placeholder="Email, nome ou id"
                />
              </Form.Field>
              <List divided inverted relaxed verticalAlign="middle">
                {searchAluno.length > 1 && renderAlunos()}
              </List>
            </Form>
          </>
        ) : (
          <>
            <div style={{ width: "100%", marginBottom: 20 }}>
              <Button
                loading={loading}
                icon
                labelPosition="left"
                color="yellow"
                size="medium"
                onClick={() => setCurrentAluno("")}
              >
                <Icon name="arrow left" />
                Escolher outro aluno
              </Button>
            </div>
            <b>Enviando link de pagamento para:</b>
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>ID</Table.HeaderCell>
                  <Table.HeaderCell>Nome</Table.HeaderCell>
                  <Table.HeaderCell>Email</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{currentAluno.id}</Table.Cell>
                  <Table.Cell>{currentAluno.nome}</Table.Cell>
                  <Table.Cell>{currentAluno.email}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <Form>
              <Form.Field>
                <label>CPF</label>
                <input value={cpf} onChange={(e) => setCpf(e.target.value)} />
              </Form.Field>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>CEP</label>
                  <input value={cep} onChange={(e) => setCep(e.target.value)} />
                </Form.Field>
                <Form.Field>
                  <label>Endereço</label>
                  <input
                    value={endereco}
                    onChange={(e) => setEndereco(e.target.value)}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Número</label>
                  <input
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>Bairro</label>
                  <input
                    value={bairro}
                    onChange={(e) => setBairro(e.target.value)}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Cidade</label>
                  <input
                    value={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Estado</label>
                  <select
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                  >
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                  </select>
                </Form.Field>
              </Form.Group>
            </Form>
            <Title>Dados do pedido</Title>
            {renderCursos()}
            <div style={{ marginTop: 30, paddingBottom: 100 }}>
              <Button
                loading={loading}
                icon
                labelPosition="right"
                positive
                floated="right"
                onClick={() => finalizar()}
              >
                <Icon name="mail" />
                Enviar link de pagamento
              </Button>
              <Button
                loading={loading}
                icon
                labelPosition="left"
                color="grey"
                floated="left"
                onClick={() => setNumCursos(numCursos + 1)}
              >
                <Icon name="plus" />
                Adicionar curso
              </Button>
            </div>
          </>
        )}
      </Container>

      {currentAluno !== "" && (
        <ValorFinal>
          <p>Valor final a ser pago pelo usuário:</p>
          <b>R${valorFinal}</b>
        </ValorFinal>
      )}
    </div>
  );
}

export default Pagamentos;
